var _defs, _path, _rect, _line, _line2, _line3, _line4, _line5, _line6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    role: "img",
    "aria-label": "SoKo tank mark",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "SoKo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "soko-icon-clip"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 18 16 L 66 16 Q 74 16 74 24 L 74 72 Q 74 80 66 80 L 18 80 Q 10 80 10 72 L 10 24 Q 10 16 18 16 Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 18 16 L 66 16 Q 74 16 74 24 L 74 72 Q 74 80 66 80 L 18 80 Q 10 80 10 72 L 10 24 Q 10 16 18 16 Z",
    fill: "none",
    stroke: "#0B3A4A",
    strokeWidth: 3.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 48,
    width: 64,
    height: 32,
    fill: "#2E7A7F",
    clipPath: "url(#soko-icon-clip)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 48,
    x2: 74,
    y2: 48,
    stroke: "#0B3A4A",
    strokeWidth: 2.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 78,
    y1: 24,
    x2: 84,
    y2: 24,
    stroke: "#0B3A4A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 78,
    y1: 36,
    x2: 84,
    y2: 36,
    stroke: "#0B3A4A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 78,
    y1: 48,
    x2: 88,
    y2: 48,
    stroke: "#0B3A4A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 78,
    y1: 60,
    x2: 84,
    y2: 60,
    stroke: "#0B3A4A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 78,
    y1: 72,
    x2: 84,
    y2: 72,
    stroke: "#0B3A4A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo_icon.704a3961877d0cd9e019009da7ebc72c.svg";
export { ForwardRef as ReactComponent };